import React from 'react'
import ILCampaignWidget from '../../components/ILCampaignWidget'
import ProPublicaHeader from '../../components/ProPublicaHeader'
import ProPublicaFooter from '../../components/ProPublicaFooter'
import PixelPing from '../../components/PixelPing'
import * as pym from 'pym.js'


class IndexPage extends React.Component {

  // @TODO can / should this be moved to a layout component?
  componentDidMount() {
    this.pymChild = new pym.Child({polling: 500})
  }

  render() {
    return (
      <div className="pg-graphic">
        <ProPublicaHeader data= {this.props.data} />
        <ILCampaignWidget data={this.props.data} />
        <ProPublicaFooter data = {this.props.data} />
        <PixelPing />
      </div>
    )
  }
}

export default IndexPage

export const query = graphql`
  query FundsQuery {
      govPrimaryJson {
        spending_date
        raised_date
        total_raised
        total_spending
        past_month_total
        past_week_total
        self_funded_total
      }
      govPrimaryJson {
        candidates {
          name
          party
          img
          incumbent
          raised
          self_funded
          spent
          raised_30days
          raised_past_week
          raised_cumulative_timeline {
            amount
            raised_date
          }
          raised_30days_timeline {
            amount
            raised_date
          }
        }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/latest/index.js